<template>
    <span ref="dropdownButtonGroup" class="btn-group">
        <button ref="dropdownButton" type="button" class="btn btn-xs btn-default dropdown-toggle"
                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <slot></slot>
        </button>
        <span ref="dropdownMenu" class="dropdown-menu bs3-padding-reset bs3-border-reset">
            <span ref="actionDateText" :id="pButtonId + 'ActionDateText'" class="datepicker actionDateText"></span>
        </span>
    </span>
</template>

<script>
import BaseMixin from "@/mixins/base-mixin";
import FormMixin from "@/mixins/form-mixin";
import FormatMixin from "@/mixins/format-mixin";

export default {
   name: "ProposalColumnDateAction",
   mixins: [BaseMixin, FormMixin, FormatMixin],
   props: {
       pButtonId: String
   },
   data: function () {
      return {
         actionDateText: null
      }
   },
   methods: {
      reset: function () {
         this.actionDateText = null;
      },
      apply: function () {

      }
   },
   mounted: function () {
      let _component = this;
      $(_component.$refs.dropdownButtonGroup).on('show.bs.dropdown', function () {
         _component.reset();
      });

      $(_component.$refs.dropdownButtonGroup).on('shown.bs.dropdown', function () {
         // Init ActionDateText.
         let $actionDateText = $(_component.$refs.actionDateText);
         $actionDateText.initFromDatePicker(
                 {
                    dateElId: $actionDateText.attr('id'),
                    linkDateElId: null,
                    bs3: true,
                    f: function (selectedDate) {
                        _component.$emit('date-selected', selectedDate);
                        $(_component.$refs.dropdownButton).dropdown('toggle');
                    }, noWeekends: false
                 });
      });

      $(_component.$refs.dropdownMenu).on("click.bs.dropdown", function (e) {
         e.stopPropagation();
      });

      // $(_component.$refs.dropdownButtonGroup).on('hide.bs.dropdown', function () {
      //    _component.$emit('media-plan-target-measures-matrix-action-close');
      // });
   }
}
</script>

<style scoped>

</style>